import { render, staticRenderFns } from "./FormElementTextInput.vue?vue&type=template&id=157bf8b3"
import script from "./FormElementTextInput.vue?vue&type=script&lang=js"
export * from "./FormElementTextInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports